<template>
	<div>
		<bv-top></bv-top>
		<van-search
				placeholder="请输入关键字查询"
				v-model="keywords"
				shape="round"
				clearable
				show-action
		>
			<template #action>
				<div style="color:#169BD5"><van-icon name="records" />全部为已读</div>
			</template>
		</van-search>
<!--		<div class="notificationList">-->
<!--			<div class="notificationIcon" style="width: 40px;display:inline">-->
<!--				<van-icon name="wechat" />-->
<!--			</div>-->
<!--			<div style="width: calc(100vw - 40px);display:inline">-->
<!--				<div class="titleDiv" style="width: 50%">-->
<!--					表决通知-->
<!--				</div>-->
<!--				<div class="dateDiv" style="width: 50%">-->
<!--					2021-01-01-->
<!--				</div>-->
<!--				<div class="contentDiv" style="width: 100%;">-->
<!--					尊敬的业主，您有一个待表决项目，请及时进行表决...-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<van-empty v-show="noResultShow" description="没有更多内容"/>
	</div>
</template>

<script>
	import Top from '@/views/components/Top'

	export default {
		name: 'NotificationList',
		components: {
			BvTop:Top
		},
		data() {
			return {
				keywords: '',
				noResultShow: true
			}
		},
		methods: {

		},
		mounted() {

		}
	}
</script>